module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Pillar-Page-Resource.3da4670e.jpg";